import { useState } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";
interface IUseFormEmpresas {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFormEmpresas = ({ setOpenModal }: IUseFormEmpresas) => {
  const { handleGetAlert } = useLayoutMainContext();
  const { setAttTable, id } = useConfigPageContext();
  const { valuesInputsEmpresas } = useContextComissoes();

  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!valuesInputsEmpresas.name?.trim())
      return handleGetAlert({ message: `Digite uma empresa` });

    setLoading(true);

    return api
      .post("/companies", valuesInputsEmpresas)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleEdit = () => {
    if (!valuesInputsEmpresas.name?.trim())
      return handleGetAlert({ message: `Digite uma empresas` });

    setLoading(true);

    return api
      .put(`/companies/${id}`, valuesInputsEmpresas)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = () => {
    if (id) {
      handleEdit();
    } else {
      handleCreate();
    }
  };

  return { handleSubmit, loading };
};
